import { borderRadius, display } from "@mui/system";

const styles = (theme) => ({
  container: {
    width: "100%",
    alignItems: "center",
    flexDirection: "column",
    display: "flex",
    gap: 1,
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    // padding: "20px",
    pb: 2,
    justifyContent: "center",
    backgroundColor: theme.palette.background.paper,
    borderRadius: "16px",
    gap: 2,
  },
  containerHeader: {
    display: "flex",

    flexDirection: { xs: "column", md: "row" },
    justifyContent: "space-between",
    alignItems: { xs: "flex-start", md: "center" },
    gap: 2,
    width: "100%",
    p: 1,
  },
  boxHeader: { display: "flex", gap: 2 },
  title: { fontWeight: "bold", fontSize: "20px" },
  BoxStack: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "@media (max-width: 664px)": {
      flexDirection: "column",
      alignItems: "flex-start",
      gap: 2,
      height: "auto",
    },
    padding: "0px 20px 0px 20px",
  },
  containerBuscar: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: 2,
    mt: 2,
    mb: 2,
  },
  containerAdd: {
    marginTop: "-3px",
  },
  searcField: {
    width: { xs: "100%", sm: "260px" },
  },
  buttomAddUser: {
    height: "40px",
  },
  boxModal: {
    position: "absolute",
    borderRadius: "16px",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: " 90%",
    maxWidth: "1000px",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    height: "600px",
  },
  containerButton: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    gap: 1,
  },
  boxAnswer: {
    mb: 1,
    display: "flex",
    alignItems: "center",
  },
  boxTitle: {
    width: "100%",
    margin: "20px 0",
  },
  containerButtonIcons: {
    display: "flex",
    gap: 1,
    flexDirection: "column",
  },
  titleAnswer: {
    width: "100%",
    margin: "5px 0 0 0",
  },
  boxPerguntas: {
    width: "100%",
    margin: "10px 0",
    height: "360px",
    overflow: "hidden",
    overflowY: "auto",
  },
  titleCampo: {
    fontWeight: "bold",
    margin: "10px 0",
  },
  containerMenuItem: {
    display: "flex",
    alignItems: "center",
    gap: 1,
  },
  containerComponentAnswer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
});

export default styles;
